export default "__VITE_ASSET__rUM2upEv__"